import { BusinessClockStatus } from './core/time/business-clock-ui';
import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
    selector: 'app-root',
    imports: [RouterOutlet, BusinessClockStatus],
    template: '<app-business-clock-status></app-business-clock-status><router-outlet></router-outlet>'
})
export class AppComponent {}
